module.exports = __webpack_public_path__ + "static/media/cafe.e895da13.jpg";